// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"guitar-style_wrapper__2DBJa","guitarImg":"guitar-style_guitarImg__2Mf_g","lineBox":"guitar-style_lineBox__3-I_g","line":"guitar-style_line__20FLl"};